module.exports = __webpack_public_path__ + "img/fan-alert.1be69cf1.gif";